import React from 'react';

const FeedbackWrapUpSectionItem = () => (
    <div className={'feedbackWrapUpSectionItem col-12'}>
        <h4>
            This must <strong>always</strong> be the last slide in a feedback learning asset.
        </h4>
        <p>It is not customizable.</p>
    </div>
);

export default FeedbackWrapUpSectionItem;
